import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import moment from "moment";

let Events = ({ events, limit }) => (
  <section id="events">
    <div className="container">
      <div className="row">
        <div className="col-lg-12 text-center">
          <h2 className="section-heading"> Upcoming Events </h2>
        </div>
      </div>
      <div className="row text-center">
        <div id="eList">
          {events.length === 0 ? (
            <h3 className="section-subheading text-muted">No current events</h3>
          ) : (
            events.slice(0, limit ? limit : events.length).map((event) => {
              event.type = "calendar";
              if (event.description) {
                if (event.description.indexOf("🎵") >= 0) {
                  event.type = "music";
                  event.description = event.description.replace("*ETM", "");
                }
                if (event.description.indexOf("🎙️") >= 0) {
                  event.type = "microphone";
                  event.description = event.description.replace("*ETP", "");
                }
                if (event.description.indexOf("🍺") >= 0) {
                  event.type = "beer";
                  event.description = event.description.replace("*ETB", "");
                }
                if (event.description.indexOf("👨‍👩‍👧‍👦") >= 0) {
                  event.type = "group";
                  event.description = event.description.replace("*ETG", "");
                }
              }
              return (
                <div
                  key={event.iCalUID}
                  className="col-md-4"
                  style={{ padding: "30px" }}
                >
                  <span className="fa-stack fa-4x">
                    <i className="fa fa-circle fa-stack-2x text-primary" />
                    <i
                      className={`fa fa-${event.type} fa-stack-1x fa-inverse`}
                    />
                  </span>
                  <h4 className="service-heading"> {event.summary} </h4>
                  <p className="text-muted">
                    {" "}
                    When:{" "}
                    {moment(event.start.dateTime).format(
                      "ddd, MMM DD YYYY, hh:mm A"
                    )}{" "}
                  </p>
                </div>
              );
            })
          )}
          {events.length > limit ? (
            <div id="eio" className="row text-center">
              <div className="col-md-12" style={{ marginTop: "25px" }}>
                <a
                  href="#eventsModal"
                  className="btn btn-xl"
                  data-toggle="modal"
                  onClick={() => {
                    document
                      .getElementById("page-top")
                      .classList.add("modal-open");
                    document.getElementById("eventsModal").style.display =
                      "block";
                    document.getElementById("eventsModal").style.overflowX =
                      "hidden";
                    document.getElementById("eventsModal").style.overflowY =
                      "auto";
                    setTimeout(function () {
                      document
                        .getElementById("eventsModal")
                        .classList.add("in");
                    }, 100);
                  }}
                >
                  View All Events
                </a>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  </section>
);

Events.propTypes = {
  events: PropTypes.array.isRequired,
  limit: PropTypes.number,
};

const mapStateToProps = (state) => {
  return {
    events: state.events.fetched ? state.events.items : [],
    fetched: state.events.fetched,
  };
};

export default connect(mapStateToProps)(Events);



// WEBPACK FOOTER //
// ./src/scenes/landingPage/components/events/Events.js